'use strict';

define('lib/analytics/blocks/keymetrics',[], function () {
  // todo: ...rest instead
  return function keyMetrics() {
    var args = Array.prototype.slice.call(arguments);
    return { metrics: args.join(',') };
  };
});

